import {z} from '@hono/zod-openapi';

import {priceReportArgumentFactSchema} from './PriceReportArgumentFactSchema';
import {priceReportArgumentSchema} from './PriceReportArgumentSchema';
import {priceReportArgumentsResponseSchema} from './PriceReportArgumentsResponseSchema';
import {priceReportObjectionSchema} from './PriceReportObjectionSchema';

// Keeps the items that match and drops the rest, e.g. a fact key or category added on the
// backend before the app that reads it is deployed.
const tolerantArraySchema = <T>(itemSchema: z.ZodType<T>) =>
  z.array(z.unknown()).transform((items) =>
    items.flatMap((item) => {
      const parsed = itemSchema.safeParse(item);
      return parsed.success ? [parsed.data] : [];
    })
  );

const clientArgumentSetSchema = z.object({
  headline: z.string(),
  arguments: tolerantArraySchema(priceReportArgumentSchema),
  objections: tolerantArraySchema(priceReportObjectionSchema),
});

/**
 * The arguments response as clients should read it: unknown facts, arguments and objections are
 * skipped instead of failing the whole response, so BE and FE can be deployed in any order.
 */
export const priceReportArgumentsClientResponseSchema = priceReportArgumentsResponseSchema.extend({
  facts: tolerantArraySchema(priceReportArgumentFactSchema),
  selling: clientArgumentSetSchema.nullable(),
  buying: clientArgumentSetSchema.nullable(),
});
